import React, { memo } from 'react'

const BarsIcon: React.FC = memo(() => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 24 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="24" height="3" rx="1.5" fill="currentColor" />
    <rect y="9.5" width="24" height="3" rx="1.5" fill="currentColor" />
    <rect y="18.5" width="24" height="3" rx="1.5" fill="currentColor" />
  </svg>
))

export { BarsIcon }
